export default "__VITE_ASSET__BFNNdwUS__"